module.exports = "<div class=\"col-lg-12\">\n  <div class=\"row \">\n    <!--Main column-->\n    <router-outlet ></router-outlet>\n  </div>\n  <!--/.Main column-->\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/news/news.component.html
// module id = 915
// module chunks = 0